module.exports = __webpack_public_path__ + "img/leftthigh-ectomorph-female.94373e36.svg";